// import axios from 'axios';
import api from '@/helpers/api'


const API_READ=`/api/user/`
const API_CREATE = API_READ
const API_UPDATE = API_READ
const API_DELETE = API_READ
const API_ASSIGN = API_READ

export default {
  namespaced:true,
  state: {
    status: '',
    users:[],
    user: {},
    errMessage: '',
    meta:{
        limit:10,
        page:1,
        total:1
    },
    filter: {}
  },
  mutations: {
    request(state){
        state.status = 'loading'
    },
    success(state){
        state.status = 'success'
    },
    error(state, {message}){
        state.status = 'error'
        state.errMessage = message
    },
    read(state, {users}){
        state.users = [... users]
    },
    read_single_success(state, {user}){
        state.user = user
    },
    switch_page(state, {meta}){
        state.meta = {...meta}
    },
    add_filter(state, {filter}) {
        state.filter = {...filter};
    },
    set_search(state, {search}){
        state.search = {...search};
    },
    clear_search(state) {
        state.search = {};
    },
  },
  actions: {
    read({commit, state}){

        commit('request')

        const {meta} = state
        const {filter} = state
        const {search} = state

        return new Promise((resolve, reject) => {
           api.request('get',API_READ,{meta, filter, search})
            .then((result) => {
                commit('read',{users:result.data.data})
                commit('switch_page', {meta: {...result.data.meta}})
                commit('success')
                return resolve(result)
            }).catch((err) => {
                commit('error', {message: err})
                return reject(err)
            });
        });
    },
    read_single({commit},id){

        commit('request');

        return new Promise((resolve,reject)=>{
            api.request('get',`${API_READ}${id}`)
            .then((result) => {
                commit('success')
                return resolve(result.data.data);
            }).catch((err) => {
                commit('error', {message: err});
                return reject(err);
            });
        })
    },
    delete({commit},id){

        commit('request');
        
        return new Promise((resolve, reject) => {
            // axios.delete(`${process.env.VUE_APP_API_HOST}/api/user/${id}`,
            // {
            //     headers: {
            //         'Authorization': 'Bearer '+localStorage.getItem('token'), 
            //     }
            // })
            api.request('delete',`${API_DELETE}${id}`)
            .then((response) => {
                commit('success')
                return resolve(response.data)   
            }).catch((err) => {
                commit('error', {message: err})
                return reject(err.response.data);
            });
        });

    },
    update({commit},{data}){

        commit('request');

        return new Promise((resolve, reject) => {
            api.request('put',`${API_UPDATE}${data.id}`,{},data)
            .then((request) => {
                commit('success');
                return resolve(request)
            }).catch((err) => {
                commit('error', {message: err})
                return reject(err)    
            });
        });


    },
    create({commit},{data}){
        
        commit('request');

        return new Promise((resolve, reject) => {
            api.request('post',API_CREATE,{},data)
            .then((request) => {
                commit('success');
                console.log('log action');
                return resolve(request)
            }).catch((err) => {
                commit('error', {message: err})
                return reject(err)
            });
        })


    },
    assign({commit},{user,entity}){
        commit('request');

        const data={
            [`${entity.key}`]:entity.id
        }

        return new Promise((resolve, reject) => {
            api.request('put',`${API_ASSIGN}${entity.name}/${user.id}`,{},{data})
            .then((request) => {
                commit('success');
                return resolve(request)
            }).catch((err) => {
                commit('error', {message: err})
                return reject(err)
            });
        })
    },
    getAvatar({commit},id){
        return new Promise((resolve, reject) => {
            api.request('get',`${API_READ}avatar/${id}`)
            .then((response) => {
                commit('success');
                return resolve(response)
            }).catch((err) => {
                commit('error', {message: err})
                return reject(err)
            });
        })
    }
  },
  getters : {
    users: ()=>state => state.users,
  }
}
